import { Controller } from "@hotwired/stimulus"

// Renders a Cloudflare Turnstile challenge into the charity enquiry form.
// Only present when TURNSTILE_SITE_KEY is configured (see
// GivingEnquirySpamCheck). Rendering explicitly, rather than relying on the
// script's automatic scan, means the widget also appears when the form is
// re-rendered by a turbo_stream after a validation error.
const SCRIPT_URL = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit"

let scriptPromise = null

function loadTurnstile() {
  if (window.turnstile) return Promise.resolve(window.turnstile)
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement("script")
      script.src = SCRIPT_URL
      script.async = true
      script.onload = () => resolve(window.turnstile)
      script.onerror = reject
      document.head.appendChild(script)
    })
  }
  return scriptPromise
}

export default class extends Controller {
  static get values() {
    return { siteKey: String }
  }

  connect() {
    loadTurnstile()
      .then((turnstile) => {
        if (!this.element.isConnected) return
        this.widgetId = turnstile.render(this.element, { sitekey: this.siteKeyValue })
      })
      .catch(() => {
        // The server fails open when Cloudflare is unreachable; nothing to do.
      })
  }

  disconnect() {
    if (this.widgetId !== undefined && window.turnstile) {
      window.turnstile.remove(this.widgetId)
    }
  }
}
